// Раздел «Администрирование» (перенос из старого Office): администрирование, клиенты, уведомления, CRM,
// анкеты, комиссии, KPI, аналитика, CMS сайта. Бэкенд — office_api/office_port/areas/admin/.
// Страницы — src/views/office/admin/<подраздел>/. Каждый подраздел правит только свой блок между метками.
// CMS: адреса для уже заведённых в меню «Офис → CMS» пунктов (cmsFaq, cmsStages, ...), у которых не было экранов.

export const pages = {
  // --- users ---
  officeAdmEmployees: "/office/admin/users/employees",
  officeAdmEmployeeGroup: "/office/admin/users/employee-group",
  officeAdmRoles: "/office/admin/users/roles",
  officeAdmFuncs: "/office/admin/users/funcs",
  officeAdmDevices: "/office/admin/users/devices",
  // --- /users ---
  // --- system ---
  officeAdmMessageTypes: "/office/admin/system/message-types",
  officeAdmMyMessageTypes: "/office/admin/system/my-message-types",
  officeAdmPositionMarks: "/office/admin/system/position-marks",
  officeAdmPositionChats: "/office/admin/system/position-chats",
  officeAdmSettings: "/office/admin/system/settings",
  officeAdmPaymentRules: "/office/admin/system/payment-rules",
  officeAdmPaymentRuleDetails: "/office/admin/system/payment-rule-details",
  officeAdmPrStatusLink: "/office/admin/system/pr-status-link",
  officeAdmDocumentTemplates: "/office/admin/system/document-templates",
  officeAdmUncheck: "/office/admin/system/uncheck",
  officeAdmClients: "/office/admin/system/clients",
  officeAdmNotifications: "/office/admin/system/notifications",
  officeAdmChats: "/office/admin/system/chats",
  officeAdmSmsManual: "/office/admin/system/sms-manual",
  // --- /system ---
  // --- crm ---
  officeAdmCrSession: "/office/admin/crm/cr-session",
  officeAdmKpi: "/office/admin/crm/kpi",
  officeAdmKpiEdit: "/office/admin/crm/kpi/edit",
  officeAdmCrmBigEmployees: "/office/admin/crm/big-employees",
  officeAdmCrmDepartments: "/office/admin/crm/departments",
  officeAdmCrmOrigins: "/office/admin/crm/origins",
  officeAdmCrmDenyReasons: "/office/admin/crm/deny-reasons",
  officeAdmCrmRequestCancel: "/office/admin/crm/request-cancel",
  officeAdmCrmRequestCanceled: "/office/admin/crm/request-canceled",
  officeAdmAnketaContractors: "/office/admin/crm/anketa",
  officeAdmAnketaCard: "/office/admin/crm/anketa/:anketa_id",
  officeAdmAnketaMasters: "/office/admin/crm/anketa-masters",
  officeAdmFeeTypes: "/office/admin/crm/fee-types",
  officeAdmFeeLinks: "/office/admin/crm/fee-links",
  officeAdmAvgRemontDays: "/office/admin/crm/avg-remont-days",
  // --- /crm ---
  // --- cms ---
  cmsWhyWe: "/cms/why-we",
  cmsFaq: "/cms/faq",
  cmsStages: "/cms/stages",
  cmsBriefs: "/cms/briefs",
  cmsContactInfo: "/cms/contact-info",
  cmsAbout: "/cms/about",
  cmsPartners: "/cms/partners",
  cmsTeam: "/cms/team",
  cmsBlog: "/cms/blog",
  cmsRemontDetails: "/cms/remont-details",
  cmsConstructorRemont: "/cms/constructor-remont",
  cmsReviews: "/cms/reviews",
  cmsClientReviews: "/cms/client-reviews",
  cmsBestResidents: "/cms/best-residents",
  cmsAspirants: "/cms/aspirants",
  cmsPresets: "/cms/presets",
  cmsPresetInfo: "/cms/preset-info",
  cmsPackDiff: "/cms/pack-diff",
  cmsConstructorDocuments: "/cms/constructor-documents",
  cmsShowRooms: "/cms/show-rooms",
  // --- /cms ---
};

export const routes = [
  // --- users ---
  { path: "/office/admin/users/employees", name: "officeAdmEmployees",
    meta: { layout: "main", title: "Ведение пользователей" },
    component: () => import("@/views/office/admin/users/Employees.vue") },
  { path: "/office/admin/users/employee-group", name: "officeAdmEmployeeGroup",
    meta: { layout: "main", title: "Привилегии пользователей" },
    component: () => import("@/views/office/admin/users/EmployeeGroup.vue") },
  { path: "/office/admin/users/roles", name: "officeAdmRoles",
    meta: { layout: "main", title: "Ведение ролей" },
    component: () => import("@/views/office/admin/users/Roles.vue") },
  { path: "/office/admin/users/funcs", name: "officeAdmFuncs",
    meta: { layout: "main", title: "Ведение процедур" },
    component: () => import("@/views/office/admin/users/Funcs.vue") },
  { path: "/office/admin/users/devices", name: "officeAdmDevices",
    meta: { layout: "main", title: "Безопасность" },
    component: () => import("@/views/office/admin/users/Devices.vue") },
  // --- /users ---
  // --- system ---
  ...[
    ["officeAdmMessageTypes", "/office/admin/system/message-types", "Ведение типов сообщений",
      () => import("@/views/office/admin/system/MessageTypes.vue")],
    ["officeAdmMyMessageTypes", "/office/admin/system/my-message-types", "Мои типы сообщений",
      () => import("@/views/office/admin/system/MyMessageTypes.vue")],
    ["officeAdmPositionMarks", "/office/admin/system/position-marks", "Статусы по этапам для должностей",
      () => import("@/views/office/admin/system/PositionMarks.vue")],
    ["officeAdmPositionChats", "/office/admin/system/position-chats", "Чаты по должностям",
      () => import("@/views/office/admin/system/PositionChats.vue")],
    ["officeAdmSettings", "/office/admin/system/settings", "Настройки",
      () => import("@/views/office/admin/system/Settings.vue")],
    ["officeAdmPaymentRules", "/office/admin/system/payment-rules", "Правила платежей",
      () => import("@/views/office/admin/system/PaymentRules.vue")],
    ["officeAdmPaymentRuleDetails", "/office/admin/system/payment-rule-details", "Детали правил платежей",
      () => import("@/views/office/admin/system/PaymentRuleDetails.vue")],
    ["officeAdmPrStatusLink", "/office/admin/system/pr-status-link", "Статусы заявок поставщику",
      () => import("@/views/office/admin/system/PrStatusLink.vue")],
    ["officeAdmDocumentTemplates", "/office/admin/system/document-templates", "Шаблоны документов",
      () => import("@/views/office/admin/system/DocumentTemplates.vue")],
    ["officeAdmUncheck", "/office/admin/system/uncheck", "Uncheck",
      () => import("@/views/office/admin/system/Uncheck.vue")],
    ["officeAdmClients", "/office/admin/system/clients", "Ведение клиентов",
      () => import("@/views/office/admin/system/Clients.vue")],
    ["officeAdmNotifications", "/office/admin/system/notifications", "Уведомления (Office)",
      () => import("@/views/office/admin/system/Notifications.vue")],
    ["officeAdmChats", "/office/admin/system/chats", "Чаты",
      () => import("@/views/office/admin/system/Chats.vue")],
    ["officeAdmSmsManual", "/office/admin/system/sms-manual", "Ручная отправка смс",
      () => import("@/views/office/admin/system/SmsManual.vue")],
  ].map(([name, path, title, component]) => ({ path, name, meta: { layout: "main", title }, component })),
  // --- /system ---
  // --- crm ---
  ...[
    ["officeAdmCrSession", "/office/admin/crm/cr-session", "Поиск по Session", () => import("@/views/office/admin/crm/CrSession.vue")],
    ["officeAdmKpi", "/office/admin/crm/kpi", "KPI", () => import("@/views/office/admin/crm/Kpi.vue")],
    ["officeAdmKpiEdit", "/office/admin/crm/kpi/edit", "Выставить KPI", () => import("@/views/office/admin/crm/KpiEdit.vue")],
    ["officeAdmCrmBigEmployees", "/office/admin/crm/big-employees", "CRM: Сотрудники BIG",
      () => import("@/views/office/admin/crm/BigEmployees.vue")],
    ["officeAdmCrmDepartments", "/office/admin/crm/departments", "CRM: Отделы BIG",
      () => import("@/views/office/admin/crm/Departments.vue")],
    ["officeAdmCrmOrigins", "/office/admin/crm/origins", "CRM: Источники лида",
      () => import("@/views/office/admin/crm/Origins.vue")],
    ["officeAdmCrmDenyReasons", "/office/admin/crm/deny-reasons", "CRM: Причины отказа",
      () => import("@/views/office/admin/crm/DenyReasons.vue")],
    ["officeAdmCrmRequestCancel", "/office/admin/crm/request-cancel", "CRM: Заявки на отказ",
      () => import("@/views/office/admin/crm/RequestCancel.vue")],
    ["officeAdmCrmRequestCanceled", "/office/admin/crm/request-canceled", "CRM: Возврат отказанных заявок",
      () => import("@/views/office/admin/crm/RequestCanceled.vue")],
    ["officeAdmAnketaContractors", "/office/admin/crm/anketa", "Анкеты подрядчиков",
      () => import("@/views/office/admin/crm/anketa/AnketaList.vue")],
    ["officeAdmAnketaCard", "/office/admin/crm/anketa/:anketa_id", "Анкета подрядчика",
      () => import("@/views/office/admin/crm/anketa/AnketaCard.vue")],
    ["officeAdmAnketaMasters", "/office/admin/crm/anketa-masters", "Анкеты мастеров",
      () => import("@/views/office/admin/crm/anketa/AnketaMasters.vue")],
    ["officeAdmFeeTypes", "/office/admin/crm/fee-types", "Комиссии: список и комиссии",
      () => import("@/views/office/admin/crm/FeeTypes.vue")],
    ["officeAdmFeeLinks", "/office/admin/crm/fee-links", "Комиссии: связка комиссий",
      () => import("@/views/office/admin/crm/FeeLinks.vue")],
    ["officeAdmAvgRemontDays", "/office/admin/crm/avg-remont-days", "Ремонты по срокам",
      () => import("@/views/office/admin/crm/AvgRemontDays.vue")],
  ].map(([name, path, title, component]) => ({ path, name, meta: { layout: "main", title }, component })),
  // --- /crm ---
  // --- cms ---
  ...[
    ["cmsWhyWe", "/cms/why-we", "CMS: Почему мы?"],
    ["cmsFaq", "/cms/faq", "CMS: FAQ"],
    ["cmsStages", "/cms/stages", "CMS: Этапы"],
    ["cmsBriefs", "/cms/briefs", "CMS: Памятки, видео"],
    ["cmsContactInfo", "/cms/contact-info", "CMS: Контакты"],
    ["cmsAbout", "/cms/about", "CMS: О нас"],
    ["cmsPartners", "/cms/partners", "CMS: Контрагенты"],
    ["cmsTeam", "/cms/team", "CMS: Команда"],
    ["cmsBlog", "/cms/blog", "CMS: Блог"],
    ["cmsRemontDetails", "/cms/remont-details", "CMS: Наш ремонт в деталях"],
    ["cmsConstructorRemont", "/cms/constructor-remont", "CMS: Конструктор ремонта"],
    ["cmsReviews", "/cms/reviews", "CMS: Отзывы"],
    ["cmsClientReviews", "/cms/client-reviews", "CMS: Отзывы клиентов"],
    ["cmsBestResidents", "/cms/best-residents", "CMS: Ремонты по ЖК"],
    ["cmsAspirants", "/cms/aspirants", "CMS: Обращения соискателей"],
    ["cmsPresets", "/cms/presets", "CMS: Галерея по пресетам"],
    ["cmsPresetInfo", "/cms/preset-info", "CMS: Инфо о пресете"],
    ["cmsPackDiff", "/cms/pack-diff", "CMS: Отличие пакетов"],
    ["cmsConstructorDocuments", "/cms/constructor-documents", "CMS: Документы конструктора"],
    ["cmsShowRooms", "/cms/show-rooms", "CMS: Шоу-румы"],
  ].map(([name, path, title]) => ({
    path, name, meta: { layout: "main", title, cmsKey: name },
    component: () => import("@/views/office/admin/cms/CmsPage.vue"),
  })),
  // --- /cms ---
];
